







import { Component, Vue } from 'vue-property-decorator';
import ResponseHandlerModule from '@/store/modules/responseHandler';

@Component({})
export default class ResponseHandler extends Vue {
    get isShow() {
        return ResponseHandlerModule.isShow;
    }

    get message() {
        return ResponseHandlerModule.message;
    }

    get type() {
        return ResponseHandlerModule.type;
    }

    closeNotify() {
        this.$store.dispatch('responseHandler/hideNotify');
    }
}
